import { Divider, Tab, Tabs } from '@mui/material';
import { map } from 'lodash';
import { tabs } from './ultis';

const RequestTab = ({ handleTabsChange, tab }) => {
  return (
    <>
      <Tabs
        indicatorColor="primary"
        onChange={handleTabsChange}
        scrollButtons="auto"
        sx={{ px: 3 }}
        textColor="primary"
        value={tab}
        variant="scrollable"
      >
        {map(tabs, (tab) => (
          <Tab key={tab.value} label={tab.label} value={tab.value} />
        ))}
      </Tabs>
      <Divider />
    </>
  );
};

export default RequestTab;
